const SCHEDULE_FIELDS = {
  publishedAt: null,
  publicationDate: '',
  publicationTime: '',
  publicationTimezone: null,
  publicationOffsetMinutes: null,
};

export const PUBLICATION_ACTIONS = {
  SAVE_DRAFT: 'save-draft',
  PUBLISH: 'publish',
};

export function hasPublicationSchedule(content) {
  return Boolean(content?.publicationDate && content?.publicationTime);
}

export function clearPublicationSchedule(content, postStatus = content?.post_status) {
  return {
    ...content,
    ...SCHEDULE_FIELDS,
    post_status: postStatus,
  };
}

/**
 * Applies a publication transition without changing the content document.
 */
export function applyPublicationAction(content, action) {
  switch (action) {
  case PUBLICATION_ACTIONS.SAVE_DRAFT:
    return clearPublicationSchedule(content, 'incomplete');

  case PUBLICATION_ACTIONS.PUBLISH:
    if (hasPublicationSchedule(content)) {
      return {
        ...content,
        post_status: 'queued',
      };
    }

    return clearPublicationSchedule(content, 'published');

  default:
    throw new Error(`Unsupported publication action: ${action}`);
  }
}
